import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({
    server: 'camara', endPoint: `image?t=${Date.now()}`, method: 'GET', body: null,
    mode: 'cors', credentials: 'omit', accept: 'text/html', contentType: 'text/html; charset=utf-8'
  })
}
